import { render, staticRenderFns } from "./NaviFollowSearchnavi.vue?vue&type=template&id=54cf3998&scoped=true&"
import script from "./NaviFollowSearchnavi.vue?vue&type=script&lang=ts&"
export * from "./NaviFollowSearchnavi.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=54cf3998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf3998",
  null
  
)

export default component.exports